import React from 'react';

export interface PickableArtifact {
  id: string;
  name: string;
  type: string;
}

interface ArtifactPickerProps {
  artifacts: PickableArtifact[];
  onSelect: (artifact: PickableArtifact) => void;
}

/**
 * Store-free, router-free artifact list for use inside modals.
 * ArtifactBrowser calls useNavigate() (throws outside a Router) — this shim
 * avoids that so it can render inside HandoffDialog. Dark-mode via Tailwind
 * dark: variants (no useTheme dependency → trivially testable).
 */
export const ArtifactPicker: React.FC<ArtifactPickerProps> = ({ artifacts, onSelect }) => {
  if (artifacts.length === 0) {
    return (
      <div className="text-center py-6 text-sm text-gray-500 dark:text-gray-400">
        No artifacts available
      </div>
    );
  }
  return (
    <ul className="divide-y divide-gray-200 dark:divide-gray-700 max-h-64 overflow-y-auto">
      {artifacts.map((a) => (
        <li key={a.id}>
          <button
            type="button"
            onClick={() => onSelect(a)}
            className="w-full flex items-center justify-between px-3 py-2 text-left
                       hover:bg-gray-100 dark:hover:bg-gray-700
                       text-gray-800 dark:text-gray-100"
          >
            <span className="truncate">{a.name}</span>
            <span className="ml-2 shrink-0 text-xs text-gray-400 dark:text-gray-500">{a.type}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};
